

































import { Component, Vue, Prop } from 'vue-property-decorator';
import { CatalogItemShortDTO, ItemStyleDTO } from '@/api';
import { getAssetUrl } from '@/utils';
import CatalogItemPrice from '@/components/CatalogItemPrice.vue';
import services from '@/services';

@Component({
  name: 'catalog-item',
  components: { CatalogItemPrice },
})
export default class Clients extends Vue {
  @Prop(Object) item!: CatalogItemShortDTO;

  itemPicUrl = (path: string) => getAssetUrl(path);

  get currentPrice() {
    return this.item.priceDiscount || this.item.price;
  }

  styleNames: ItemStyleDTO[] = [];

  styles: string[] = [];

  loading = false;

  show = false;

  get filteredStyleNames() {
    return this.styleNames.filter(style => style.gender === this.item.gender);
  }

  async onShow() {
    try {
      this.loading = true;
      const { data: styles } = await services.catalogService().catalogEndpointGetItemStyleNamess();
      this.styleNames = styles;
      this.styles = [];
      if (this.item && this.item.id != null) {
        const { data: names } = await services.catalogService()
          .catalogEndpointGetItemStyles(this.item.id);
        this.styles = names;
      }
    } catch (e) {
      this.$message.error(e);
    } finally {
      this.loading = false;
    }
  }

  onHide() {
    this.saveStyles();
  }

  async saveStyles() {
    if (this.item && this.item.id != null) {
      await services.catalogService()
        .catalogEndpointSetItemStyles(this.item.id, this.styles);
    }
  }

  close() {
    this.show = false;
  }
}
